import $http from 'axios';

export class TreatmentItemSmsRepo {
  async migrate(clinicId: number) {
    return $http.post('/treatment_item_smses/migrate', {
      clinicId,
    });
  }
}
